import DOMPurify from "dompurify";
import { SELECTORS } from "./constants";

// Scrolls the chat container to the bottom after a new message is added
function scrollToBottom(wrapper) {
  const animateContainer = wrapper.closest(
    ".mobius-dialogue-modal__description.mobius-dialogue-modal__description_drawer",
  );
  const chatContainer = animateContainer?.querySelector(
    ".mobius-dialogue-modal__styled-drawer-content",
  );

  if (animateContainer && chatContainer) {
    animateContainer.scrollTo({
      top: chatContainer.scrollHeight,
      behavior: "smooth",
    });
  }
}

// Displays a message in the chat UI, either from the agent or the user
// `type` can be "agent", "user", "error, or "info"
export function displayMessage(wrapper, message, type) {
  const msgsElem = wrapper.querySelector(SELECTORS.MESSAGES_ELEMENT);
  msgsElem.insertAdjacentHTML("beforeend", DOMPurify.sanitize(
    `<div class="reco-chat-message chat-message-${type}">${message}</div><div class="clearfix"></div>`,
  ));
  scrollToBottom(wrapper);
}

// Displays a 'consultant unavailable' message in the chat UI
export function displayAgentUnavailable(wrapper) {
  const msgsElem = wrapper.querySelector(SELECTORS.MESSAGES_ELEMENT);
  msgsElem.insertAdjacentHTML("beforeend", DOMPurify.sanitize(
    `<div class="reco-chat-message">
      <div class="chat-message-agent-unavailable">
        Consultant unavailable
      </div>
      <div class="chat-message-agent-unavailable-information">
        There are no consultants available right now.
        <br>
        Please, call us on +44 1604 279528 to speak with someone right away or try again later.
      </div>
    </div><div class="clearfix"></div>`,
  ));
  scrollToBottom(wrapper);
}

// Manages UI state whilst waiting for a response; disables input and shows loader animation
// TODO: Refactor this - we'll want to disable only some of the UI when the user is waiting for live chat, for example
export function setSendingState(wrapper, chatInput, isSending, showLiveChatPrompt = false) {
  const sendButton = wrapper.querySelector(SELECTORS.SEND_BUTTON);
  const loaderElem = wrapper.querySelector(".reco-chat-loader-wrapper");

  chatInput.disabled = isSending;
  sendButton.classList[isSending ? "add" : "remove"]("disabled-input");
  if (loaderElem) loaderElem.style.display = isSending ? "block" : "";

  const inlinePrompts = wrapper.querySelector(".reco-chat-prompts-outer");
  const liveChatPrompt = wrapper.querySelector(".reco-chat-live-chat-prompt");
  if (isSending) {
    inlinePrompts.style.display = "none";
    liveChatPrompt.style.display = "none";
  } else {
    if (showLiveChatPrompt) {
      liveChatPrompt.style.display = "";
    } else {
      inlinePrompts.style.display = "";
    }
  }
}

// Sets the height of the chat input to fit its content
export function setChatInputHeight(input) {
  input.style.height = "0";
  input.style.height = `${input.scrollHeight}px`;
}
